require('./OKIban.scss');
// @ vendor
const React = require('react');
const ReactDOM = require('react-dom');
const classnames = require('classnames');
const { PropTypes } = require('prop-types');
const { connect } = require('react-redux');
const IBAN = require('iban');
// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ actions
const okIbanActions = require('../../actions/OKIban');
// @ components
const { OKInput } = require('commonsComponents/OKInput');
const { isValidCCC } = require('../../utilities/CCCValidationHelper');
// @ constants
const IBAN_SIZE = 24;
const CCC_SIZE = 20;
const ONLY_LETTERS_NUMBERS_REGEX = /[^a-zA-Z0-9]/g;

class OKIban extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isIBAN: true,
            value: '',
            isFirst: true,
            regex:'',
            length: '29',
            typeEvent: '',
            appliedReset: false
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.getValidation = this.getValidation.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
        this.handleOnPaste = this.handleOnPaste.bind(this);
    }

    componentDidMount() {
        const { immIban } = this.props;
        const iban = immIban.get('iban');

        if(iban) {
            this.setState({value: iban});
        }
    }

    componentDidUpdate() {
        const { immIban } = this.props;
        const resetNeeded = immIban.get('resetNeeded');
        resetNeeded && !this.state.appliedReset && this.setState(() => ({ value: '', appliedReset: true}))
    }

    componentWillMount() {
        this.timer = 0;
    }

    validBankEntity(updateValue) {
        const { entitiesToValidate, notAllowedEntities, errorEntity } = this.props;
        const entity = updateValue.slice(5,9);
        let isValid = true;
        let errorMessage = ""

        if (entitiesToValidate) {
            isValid = entitiesToValidate.find(e => e.get('id') === entity);
            errorMessage = errorEntity
        }

        if (notAllowedEntities){
            const notAllowedEntity = notAllowedEntities.find(element => element.code === entity);
            isValid = notAllowedEntity === undefined
            errorMessage = notAllowedEntity ? notAllowedEntity.errorMessage  : ""
        }

        return { isValid, errorMessage };
    }

    validCountry(value) {
        const { validCountries, errorCountry } = this.props
        const isValid = validCountries.some(country => value.includes(country))

        return { isValid, errorMessage: errorCountry }
    }

    getValidation(input, updatedState) {
        const { verifing, eventRecoding } = this.props;
        const length = input.length;
        const value = input.replace(/(.{4})/g, '$1 ').trim();
        const isIban = updatedState.isIBAN;

        if((isIban && length === IBAN_SIZE) || (!isIban && length === CCC_SIZE)) {
            verifing();
            setTimeout(()=> {
                this.handleValidation(input, updatedState, (valid, updatedState) => {
                    const { handleValidationError, immIban } = this.props;
                    if(!valid && handleValidationError){
                        handleValidationError(immIban.get('error'));
                    }

                    this.setState(updatedState);
                });
            }, 500);
        } else {
            eventRecoding(false, "invalidFormat");
        }

        updatedState.value = value;

        return updatedState;
    }

    makeValidations(value) {
        const validBankEntity = this.validBankEntity(value)
        const validCountry = this.validCountry(value);

        if (!validBankEntity.isValid) {
            return validBankEntity
        }

        if (!validCountry.isValid) {
            return validCountry
        }

        return {
            isValid: true
        }
    }

    handleValidation(input, updatedState, callback) {
        const { setIban, setCCC, setError, errorEntity, errorFormat, eventRecoding, withImmediateValidation } = this.props;
        let updateValue = input.replace(/(.{4})/g, '$1 ').trim();
        let valid;

        if(IBAN.isValid(input)) {
            updateValue = updateValue.toUpperCase();
            const {isValid, errorMessage} = this.makeValidations(updateValue)
            valid = isValid
            if (valid) {
                updateValue = updateValue;
                withImmediateValidation && setIban(updateValue);
                eventRecoding(true, "", updateValue);
            } else {
                setError(errorMessage);
                eventRecoding(false, "invalidFormat");
            }
        } else if(isValidCCC(input)) {
            const iban = IBAN.fromBBAN('ES', input).replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim().toUpperCase();
            const data = {
                ccc: updateValue,
                iban: iban
            };
            updateValue = iban;
            valid = this.validBankEntity(updateValue);
            updatedState.regex = /^[A-Za-z0-9\b]+$/;
            updatedState.isIBAN = true;
            updatedState.length = '29';
            if (valid) {
                setCCC(data);
                eventRecoding(true);
            } else {
                eventRecoding(false, "invalidFormat");
                setError(errorEntity);
            }
        } else {
           setError(errorFormat);
        }

        updatedState.value = updateValue;
        updatedState.appliedReset = false;
        callback(valid, updatedState);
    }

    getValues(input) {
        let data = {
            isIBAN: true,
            regex: '',
            isFirst: true,
            length: '29',
            typeEvent: '',
            appliedReset: false
        };

        if(input.length && isNaN(input)) {
            data = {
                isIBAN: true,
                regex: /^[A-Za-z0-9\b]+$/,
                isFirst: false,
                length: '29',
                typeEvent: '',
                appliedReset: false
            };
        } else if(input.length && !isNaN(input)) {
            data = {
                isIBAN: false,
                regex: /^[0-9\b]+$/,
                isFirst: false,
                length: '24',
                typeEvent: '',
                appliedReset: false
            };
        }

        return data;
    }

    validation(input, updatedState) {
        if(input.length > 0 && updatedState.regex.test(input)) {
            updatedState = this.getValidation(input, updatedState);
        }

        return updatedState;
    }

    handleOnPaste(event) {
        const input = event.target.value.split(' ').join('');
        const char = input.charAt(0);
        let updatedState = this.getValues(char);
        updatedState.value = input.replace(/(.{4})/g, '$1 ').trim();

        return updatedState;
    }

    handlePaste(input) {
        const { reset, setError, errorFormat } = this.props;
        const char = input.charAt(0);
        let updatedState = this.getValues(char);
        updatedState.value = input.replace(/(.{4})/g, '$1 ').trim();

        reset();
        if((updatedState.isIBAN && input.length === IBAN_SIZE) || (!updatedState.isIBAN && input.length === CCC_SIZE)) {
            updatedState = this.validation(input, updatedState)
        } else {
            const { isValid, errorMessage } = this.validCountry(input)
            setError(isValid ? errorFormat : errorMessage);
        }

        return updatedState;
    }

    handleOnDelete(input) {
        const { reset } = this.props;
        const { regex } = this.state;

        const value = input.replace(/(.{4})/g, '$1 ').trim();
        let updatedState = this.state;

        reset();
        if(!input.length) {
            updatedState = this.getValues('');
            updatedState.value = value;
        } else {
            if (!regex) {
                const char = input.charAt(0);
                const values = this.getValues(char);
                updatedState.regex = values.regex;  
            } 
            if(updatedState.regex && updatedState.regex.test(input)){
                updatedState = this.getValidation(input, updatedState);
            }
        } 
        return updatedState;
    }

    handleOnType(input) {
        let updatedState = this.state;

        if(updatedState.isFirst || input.length === 1) {
            const char = input.charAt(0);
            updatedState = this.getValues(char);
            updatedState = this.validation(input, updatedState);
        } else {
            updatedState = this.validation(input, updatedState);
        }

        return updatedState;
    }

    handleOnChange(event) {
        const key = this.state.typeEvent;
        const value = event.target.value.replace(ONLY_LETTERS_NUMBERS_REGEX, '').replace(/(.{4})/g, '$1 ').trim();
        const input = value.split(' ').join('');

        const selectionStart = event.target.selectionStart
        const nextCharacter = value.charAt(selectionStart - 1)

        let caret = nextCharacter === " " ? selectionStart + 1 : selectionStart
        const element = event.target

        let updatedState = {};

        if (key === "Paste") {
            updatedState = this.handlePaste(input);
        } else if (key === "Delete") {
            updatedState = this.handleOnDelete(input);
            caret = selectionStart
        } else if (key !== "Space") {
            updatedState = this.handleOnType(input);
        }

        this.setState(updatedState);

        window.requestAnimationFrame(() => {
            element.setSelectionRange(caret, caret)
        })
    }

    handleOnBlur(event) {
        const { setError, errorFormat, errorRequired } = this.props;
        const input = event.target.value.replace(ONLY_LETTERS_NUMBERS_REGEX, '').trim();
        const isIban = this.state.isIBAN;
        const length = input.length;

        if (!length) {
            return setError(errorRequired);
          }
        if ((isIban && length !== IBAN_SIZE) || (!isIban && length !== CCC_SIZE)) {
            const { isValid, errorMessage } = this.validCountry(input)
            setError(isValid ? errorFormat : errorMessage);
        }
    }

    handleOnKeyDown(event) {
        const key = event.key;
        let updatedState = this.state;
        updatedState.typeEvent = '';

        if(key === "Delete" || key === "Backspace") {
            updatedState.typeEvent = "Delete";
        } else if(key === 'v' && event.ctrlKey) {
            updatedState.typeEvent = "Paste";
        } else if(key === ' ') {
            updatedState.typeEvent = "Space";
        }

        this.setState(updatedState);
    }

    render() {
        const { immIban, disabled, placeholder } = this.props;
        const textError = (immIban.get('error')) ? formatText(immIban.get('error')) : null;
        const spinnerCheckClass= classnames({
            'spinner' : immIban.get('isFetching'),
            'iban-component__icon-success' : immIban.get('verified')
        });

        return (
            <section className="iban-component">
                <OKInput
                    value = {this.state.value}
                    placeholder={placeholder}
                    onChange = {this.handleOnChange}
                    onBlur = {this.handleOnBlur}
                    onKeyDown = {this.handleOnKeyDown}
                    onPaste = {this.handleOnPaste}
                    type = 'text'
                    errorState = {!!(immIban.get('error'))}
                    errorMessage = {textError}
                    disabled = {immIban.get('isFetching') || disabled}
                    maxLength = {this.state.length}
                />
                <div className = {spinnerCheckClass} />
            </section>
        );
    }
}

OKIban.propTypes = {
    errorEntity: PropTypes.string,
    errorFormat: PropTypes.string,
    disabled: PropTypes.bool,
    entitiesToValidate: PropTypes.any,
    handleValidationError: PropTypes.func
}

OKIban.defaultProps = {
    disabled: false
}

module.exports.constructor = OKIban;
module.exports.OKIban = connect(
    state => ({
        immIban: state.iban
    }),
    {
        verifing: okIbanActions.verifing,
        setIban: okIbanActions.saveIban,
        setCCC: okIbanActions.saveCCC,
        setError: okIbanActions.error,
        reset: okIbanActions.reset
    }
)(OKIban);